<template>
        <v-layout wrap>
            <v-flex xs12 mt-2>

                <vue-content-loading :width="800" :height="45" :speed="2" primary="#d2d6dd" secondary="#f2f3fc">
                    <rect x="0" y="17" rx="8" ry="8" width="150" height="18" />
                    <rect x="160" y="17" rx="8" ry="8" width="100" height="18" />
                </vue-content-loading>
                <v-divider></v-divider>
                <vue-content-loading :width="800" :height="50" :speed="2" primary="#d2d6dd" secondary="#f2f3fc">
                    <rect x="0" y="17" rx="8" ry="8" width="90" height="12" />
                    <rect x="100" y="17" rx="8" ry="8" width="15" height="12" />
                    <rect x="125" y="17" rx="8" ry="8" width="80" height="12" />
                </vue-content-loading>


                <v-card elevation="20">
                    <vue-content-loading :width="800" :height="50" :speed="2" primary="#d2d6dd" secondary="#f2f3fc">

                        <circle cx="30" cy="30" r="20" />

                        <rect x="65" y="17" rx="5" ry="5" width="100" height="12" />


                        <rect x="65" y="35" rx="5" ry="5" width="10" height="10" />
                        <rect x="78" y="35" rx="5" ry="5" width="10" height="10" />
                        <rect x="91" y="35" rx="5" ry="5" width="10" height="10" />
                        <rect x="104" y="35" rx="5" ry="5" width="10" height="10" />
                        <rect x="117" y="35" rx="5" ry="5" width="10" height="10" />


                        <rect x="135" y="35" rx="5" ry="5" width="40" height="10" />

                    </vue-content-loading>

                    <v-divider></v-divider>

                    <v-sheet height="70" class="pa-3">

                        <vue-content-loading :width="800" :height="60" :speed="2" primary="#d2d6dd" secondary="#f2f3fc">
                            <rect x="0" y="0" rx="3" ry="3" width="90" height="8" />
                            <rect x="100" y="0" rx="3" ry="3" width="20" height="8" />
                            <rect x="130" y="0" rx="3" ry="3" width="80" height="8" />

                            <rect x="0" y="15" rx="3" ry="3" width="50" height="8" />
                            <rect x="60" y="15" rx="3" ry="3" width="90" height="8" />
                            <rect x="160" y="15" rx="3" ry="3" width="30" height="8" />
                        </vue-content-loading>

                    </v-sheet>

                    <v-divider></v-divider>

                    <v-flex xs12 pa-2>
                        <vue-content-loading :width="800" :height="40" :speed="2" primary="#d2d6dd" secondary="#f2f3fc">
                            <rect x="0" y="0" rx="0" ry="0" width="40" height="40" />
                            <rect x="46" y="0" rx="0" ry="0" width="50" height="40" />
                            <rect x="102" y="0" rx="0" ry="0" width="40" height="40" />
                        </vue-content-loading>
                    </v-flex>

                </v-card>

                <v-flex xs12 mt-4 pt-3>
                    <vcl-code :width="400" primary="#d2d6dd" secondary="#f2f3fc"></vcl-code>
                </v-flex>

            </v-flex>
        </v-layout>

</template>

<script>
    import VueContentLoading, {VclFacebook, VclInstagram, VclCode} from 'vue-content-loading';

    export default{
        components:{
            VueContentLoading,
            VclFacebook,
            VclInstagram,
            VclCode
        }
    }
</script>